import React from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import overlayFactory from "react-bootstrap-table2-overlay";
import { DropdownButton, Dropdown, ButtonGroup } from "react-bootstrap";
import {
  releasePnrHandler,
  rejectPnrHandler,
  // sendTicketInEmail,
} from "app/services/memberService";
import queryString from "app/services/queryStringService";
import PassengerModal from "./Components/Booking/PassengerModal"; //./PassengerModal.jsx";
import TicketModal from "./Components/Booking/TicketModal";
import _ from "lodash";
import Swal from "sweetalert2";
import { MdEdit, MdDelete } from "react-icons/md";
// import { Row, Col, DropdownButton, Dropdown, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import config from "config.json";
import moment from "moment";
import { MdRefresh, MdSearch } from "react-icons/md";
import { AiFillFileExcel } from "react-icons/ai";
import Tooltip from "rc-tooltip";
import {
  getBookingHistory,
  ExportBookingHistory,
  bookingDetails,
} from "./Components/Service/bookingService";
import { useState, useEffect } from "react";

const { apiUrl, dateTimeFormat } = config;

function BookingHistory() {
  const [state, setState] = useState({
    showPassenger: false,
    showTicketModal: false,
    ticketData: {},
    passengers: [],
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,

    FromDate: "",
    ToDate: "",
    SearchBy: "Booking",
    PNR: "",
  });

  const dateFormater = (cell, row) => {
    if (cell) {
      return moment(cell).format(dateTimeFormat);
    }
  };
  // TimeFormater = (cell, row) => {
  //   const date = format(
  //     new Date(cell ? cell : new Date()).getTime(),
  //     "dd MMM, yyyy"
  //   );
  //   return date;
  // };
  const charterHandeler = (row) => {
    let updateBtnModal = row.coRelationId;
    let releasePnr = row.pnr;

    if (updateBtnModal.includes("CHARTER") && releasePnr) {
      Swal.fire({
        title: `Update PNR `,
        //input: "text",
        html: `<input id="update_pnr" placeholder="Enter Your PNR " class="swal2-input form-control" type="text">
          <input id="hdnmemPnrIdUpdate" placeholder="Enter Your PNR " class="swal2-input form-control" type="hidden" value=${row.id}>`,
        confirmButtonText: "Update",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const data = {
            pnr: document.getElementById("update_pnr").value,
            bookingDetailsId:
              document.getElementById("hdnmemPnrIdUpdate").value,
          };
          if (!data.pnr || data.pnr == null) {
            Swal.showValidationMessage(`Please enter a valid Pnr.`);
            return false;
          } else {
            const res = await releasePnrHandler(data);
            return res;
          }
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (result.value.status == "Success") {
            Swal.fire({
              icon: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
            await getBookingHistory();
          } else {
            Swal.fire({
              title: "Cancelled!",
              text: "Permission denied.",
              type: "error",
              icon: "error",
              timer: 1000,
            });
          }
        }
      });
    } else if (updateBtnModal.includes("CHARTER") && !releasePnr) {
      Swal.fire({
        title: `Release PNR `,
        //input: "text",
        html: `<input id="txt_pnr" placeholder="Enter Your PNR " class="swal2-input form-control" type="text">
          <input id="hdnmemPnrId" placeholder="Enter Your PNR " class="swal2-input form-control" type="hidden" value=${row.id}>`,
        confirmButtonText: "Release",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //  debugger;
          const data = {
            pnr: document.getElementById("txt_pnr").value,
            bookingDetailsId: document.getElementById("hdnmemPnrId").value,
            //remarks: document.getElementById("txt_remark").value,
          };
          if (!data.pnr || data.pnr == null) {
            Swal.showValidationMessage(`Please enter a valid Pnr.`);
            return false;
          } else {
            const res = await releasePnrHandler(data);
            return res;
          }
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (result.value.status == "Success") {
            await getBookingHistory();
            Swal.fire({
              text: "Pnr successful",
              //  `Transaction processed successfully \n Your Total Balance : ${result.value.data}`,
              timer: 1000,
            });
          } else {
            Swal.fire("Release failed", `${result.value.message}`, "error");
          }
        }
      });
    }
  };

  const actionFormatter = (cell, row) => {
    if (row.currentStatus == "PENDING") {
      return (
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item onClick={() => charterHandeler(row)}>
            <MdEdit className="text-primary mr-4" size={15}></MdEdit>Release PNR
          </Dropdown.Item>

          <Dropdown.Item
            href="#"
            onClick={() => {
              Swal.fire({
                title: `Are you sure?`,
                text: "You won't be able to revert this!",
                html: `
                 <input id="bookingDetailsId" placeholder="Enter Your PNR " class="swal2-input form-control" type="hidden" value=${row.id}>`,
                // confirmButtonText: "Update",
                // showLoaderOnConfirm: true,

                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No",
                // preConfirm: async () => {

                // },
              }).then(async (result) => {
                if (result.isConfirmed) {
                  //debugger
                  const data = {
                    bookingDetailsId:
                      document.getElementById("bookingDetailsId").value,
                  };
                  const res = await rejectPnrHandler(data);
                  //debugger;
                  if (res.status == "Success") {
                    Swal.fire({
                      icon: "success",
                      title: "PNR Rejected Successfully",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    await getBookingHistory();
                  } else {
                    Swal.fire({
                      title: "Cancelled!",
                      text: "Permission denied.",
                      type: "error",
                      icon: "error",
                      timer: 1000,
                    });
                  }
                }
              });
              // Swal.fire({
              //   title: "Are you sure?",
              //   text: "You won't be able to revert this!",
              //   icon: "warning",
              //   showCancelButton: true,
              //   confirmButtonColor: "#3085d6",
              //   cancelButtonColor: "#d33",
              //   confirmButtonText: "Yes, delete it!",
              //   cancelButtonText: "No",
              // }).then((result) => {
              //   if (result.value) {
              //   } else {
              //     Swal.fire({
              //       title: "Cancelled!",
              //       text: "Permission denied.",
              //       type: "error",
              //       icon: "error",
              //       timer: 1500,
              //     });
              //   }
              // });
            }}
          >
            <MdDelete className="text-danger mr-4" size={15}></MdDelete>Reject
            PNR
          </Dropdown.Item>
        </DropdownButton>
      );
    } else {
      return (
        <DropdownButton
          variant="outline-primary"
          title="Action"
          disabled
          size="sm"
        ></DropdownButton>
      );
    }
  };

  const passengerFormatter = (cell, row) => {
    // console.log(row.passengerList);
    return (
      <Button onClick={(e) => getPassengerDetails(e, row)}> Passenger</Button>
    );
  };
  // sendTicketInEmailHandler = async (cell, row) => {
  //   const data = await sendTicketInEmail(row.id);
  //   if (data.status === "Success") {
  //     Swal.fire("Send!", data.message, "success");
  //   }
  // };

  const ticketFormatter = (cell, row) => {
    if (row.currentStatus == "SUCCESS") {
      return (
        <>
          <ButtonGroup aria-label="Basic example">
            <Button
              variant="outline-primary"
              size="xs"
              //  onClick={(e) =>  getTicketDetails(e, row)}
              onClick={(e) => {
                PrintWebTicket(row.coRelationId);
              }}
            >
              {" "}
              Ticket
            </Button>

            <Button
              variant="outline-primary"
              size="xs"
              // onClick={(e) =>  sendTicketInEmailHandler(e, row)}
            >
              Send Mail
            </Button>
          </ButtonGroup>
        </>
      );
    } else {
      return (
        <Button variant="outline-primary" disabled>
          {" "}
          Ticket
        </Button>
      );
    }
  };
  const getPassengerDetails = async (e, value) => {
    console.log(value);
    const response = await bookingDetails(value.id);
    // console.log(response);
    setState((prev) => ({
      ...prev,
      passengers: value.passengerList,
      showPassenger: true,
    }));
  };
  const getTicketDetails = async (e, value) => {
    const response = await bookingDetails(value.id);
    //  console.log(response);
    setState((prev) => ({
      ...prev,
      ticketData: response.data,
      showTicketModal: true,
    }));
  };
  const PrintWebTicket = (traceId) => {
    window.open(
      //"http://testapi.need82dot.com/api/v1/flight/print-ticket/" + traceId
      `${apiUrl}/flight/print-ticket/` + traceId
    );
  };
  const handlePassengerClose = () => {
    setState((prev) => ({
      ...prev,
      showPassenger: false,
    }));
  };

  const handleClose = () => {
    setState((prev) => ({
      ...prev,
      showTicketModal: false,
    }));
  };
  const columns = [
    // {
    //   dataField: "invoiceDate",
    //   text: "Invoice Date",
    //   formatter:  dateFormater,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "100px", textAlign: "center" };
    //   },
    // },
    {
      dataField: "airportDeparture.cityCode",
      text: "From",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDestination.cityCode",
      text: "To",
      headerStyle: (colum, colIndex) => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "departureDate",
      text: "Departure Date",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: dateFormater,
    },
    {
      dataField: "invoiceDate",
      text: "Booking Date",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: dateFormater,
    },

    {
      dataField: "pnr",
      text: "PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "currentStatus",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "user.normalizedUserName",
      text: "User",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "",
      text: "Update PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },

      formatter: actionFormatter,
    },

    {
      dataField: "adminIGst",
      text: "passenger ",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: passengerFormatter,
    },
    {
      dataField: "adminSGst",
      text: "Ticket ",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: ticketFormatter,
    },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    return style;
  };
  const NoDataIndication = () => {
    const { loading } = state;
    //alert(loading);
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const exportAllBookingHistory = async () => {
    const { page, sizePerPage, FromDate, ToDate, SearchBy, PNR } = state;
    const query = queryString.getQueryStringFromObj({
      FromDate,
      ToDate,
      SearchBy,
      PNR,
    });
    if (state.dataCount !== 0) {
      setState((prev) => ({
        ...prev,
        loading: true,
      }));
    }

    const response = await ExportBookingHistory(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_TransactionBooking.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setState((prev) => ({
      ...prev,
      loading: false,
    }));
  };

  const loadBookingDetails = async () => {
    const {
      page,
      sizePerPage,
      affiliateId,
      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,
      group,
      FromDate,
      ToDate,
      SearchBy,
      PNR,
    } = state;
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      affiliateId,
      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,
      group,
      FromDate,
      ToDate,
      SearchBy,
      PNR,
    });
    if (state.dataCount !== 0) {
      setState((prev) => ({
        ...prev,
        loading: true,
      }));
    }

    const response = await getBookingHistory(query);
    //  console.log(response);

    const data = response.data.data;

    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setState((prev) => ({
      ...prev,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
  };

  useEffect(() => {
    loadBookingDetails();
  }, []);

  // const handleSearch = async () => {
  //   setState((prev) => ({
  //     ...prev,
  //     page: 1,
  //     sizePerPage: 10,
  //   }));

  //   setTimeout(async () => {
  //     await loadBookingDetails();
  //   }, 10);
  // };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    //debugger;
    const currentIndex = (page - 1) * sizePerPage;
    setState((prev) => ({
      ...prev,
      page,
      sizePerPage,
    }));
    setTimeout(async () => {
      await loadBookingDetails();
    }, 10);
  };

  const handleSearchChanges = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setTimeout(async () => {
      await loadBookingDetails();
    }, 10);
  };

  const handleExport = async () => {
    setState((prev) => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
    }));

    setTimeout(async () => {
      await exportAllBookingHistory();
    }, 10);
  };

  const refreshFilter = async (e) => {
    setState((prev) => ({
      ...prev,
      FromDate: "",
      ToDate: "",
      SearchBy: "",
      PNR: "",
    }));
    setTimeout(async () => {
      await loadBookingDetails();
    }, 10);
  };

  const { data, sizePerPage, page, dataCount, loading } = state;

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <div>
        <Helmet>
          <title>Booking History</title>
        </Helmet>
        <Breadcrumb routeSegments={[{ name: "Booking History" }]}></Breadcrumb>

        <div className="card card-body text-left " id="bookingHistory">
          <div className="card-body p-0 mr-2 ">
            <div className=" mx-auto">
              <div className="bookingList-header">
                <div className="row ">
                  <div className="col-md-3 col-12">
                    <div className="form-group">
                      <label> Date From</label>
                    </div>
                    <input
                      type="date"
                      className="form-control"
                      name="FromDate"
                      // placeholder="Date From"
                      value={state.FromDate}
                      onChange={handleSearchChanges}
                      max={moment().format("YYYY-MM-DD")}
                    />
                  </div>
                  <div className="col-md-3 col-12">
                    <div className="form-group">
                      <label> Date To</label>
                    </div>
                    <input
                      type="date"
                      className="form-control"
                      name="ToDate"
                      //  placeholder="Date To"
                      value={state.ToDate}
                      onChange={handleSearchChanges}
                      max={moment().format("YYYY-MM-DD")}
                    />
                  </div>
                  <div className="col-md-3 col-12">
                    <div className="form-group">
                      <label> Search PNR</label>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      name="PNR"
                      value={state.PNR}
                      onChange={handleSearchChanges}
                    />
                  </div>
                  <div
                    className="col d-flex justify-content-end mb-3"
                    style={{ marginTop: "3%" }}
                  >
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleSearchChanges}
                    >
                      <MdSearch className="" size={18} />
                    </button>
                    <button
                      className="btn btn-outline-primary mx-2"
                      onClick={refreshFilter}
                    >
                      <MdRefresh className="" size={18} />
                    </button>
                    <Tooltip placement="top" overlay="Export Excel">
                      <Button
                        variant="outline-primary"
                        //className="ml-2"
                        onClick={handleExport}
                      >
                        <AiFillFileExcel className="" size={"2em"} />
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
            <BootstrapTable
              hover
              remote
              keyField="id"
              data={data}
              columns={columns}
              pagination={paginationFactory(paginationOptions)}
              onTableChange={handleTableChange}
              noDataIndication={() => <NoDataIndication />}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
          <TicketModal
            show={state.showTicketModal}
            handleClose={handleClose}
            response={state.ticketData}
          />
          <PassengerModal
            show={state.showPassenger}
            handleClose={handlePassengerClose}
            response={state.passengers}
          />
        </div>
      </div>
    </>
  );
}
export default BookingHistory;
